import { render, staticRenderFns } from "./DocumentApercu.vue?vue&type=template&id=4039aeea&scoped=true&"
import script from "./DocumentApercu.vue?vue&type=script&lang=js&"
export * from "./DocumentApercu.vue?vue&type=script&lang=js&"
import style0 from "./DocumentApercu.vue?vue&type=style&index=0&id=4039aeea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4039aeea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4039aeea')) {
      api.createRecord('4039aeea', component.options)
    } else {
      api.reload('4039aeea', component.options)
    }
    module.hot.accept("./DocumentApercu.vue?vue&type=template&id=4039aeea&scoped=true&", function () {
      api.rerender('4039aeea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/DocumentApercu.vue"
export default component.exports